// Load all the controllers within this directory and all subdirectories. 
// Controller files must be named *_controller.js.

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import NestedForm from '/node_modules/stimulus-rails-nested-form/dist/stimulus-rails-nested-form.umd.js'
import Popover from '/node_modules/stimulus-popover/dist/stimulus-popover.umd.js'

const application = Application.start()

const context = require.context("controllers", true, /_controller\.js$/)

// Import style for flatpickr
// Manually register Flatpickr as a stimulus controller
import CustomFlatpickr from './custom_flatpickr.js'
application.register('flatpickr', CustomFlatpickr)

application.register('nested-form', NestedForm)

import CustomAutocomplete from './custom_autocomplete.js'
application.register('autocomplete', CustomAutocomplete)

import CustomMultiselect from './custom_multiselect.js'
application.register('multiselect', CustomMultiselect)

import Card from './card.js'
application.register('card', Card)

import CopyDown from './copy_down.js'
application.register('copy-down', CopyDown)

import Loading from './loading.js'
application.register('loading', Loading)

application.register('popover', Popover)

import CharacterCounter from '/node_modules/stimulus-character-counter/dist/stimulus-character-counter.umd.js'
application.register('character-counter', CharacterCounter)

application.load(definitionsFromContext(context))